import { useMemo } from "react";
import { useTokenPricesQuery } from "../redux/slices/api/generalApiSlice";
import { localTokenPrices } from "../utils/localData";

const useTokenPrices = () => {
  const tokenPricesResult = useTokenPricesQuery();
  const { data, isLoading, isError } = useMemo(
    () => tokenPricesResult,
    [tokenPricesResult]
  );

  const tokenPrices = useMemo(() => {
    const firstValue = Object.values(data || {})[0];
    if ((!data || !firstValue) && localTokenPrices()) {
      return localTokenPrices();
    } else if (firstValue) {
      localStorage.setItem("token-prices", JSON.stringify(data));
    }
    return data;
  }, [data]);

  const toDollar = ({ token, amount, decimal = 4 }) => {
    if (isLoading || isError) return null;
    const price = tokenPrices?.[token];
    const calcPrice = price != null && price > 0 ? Number((price * amount).toFixed(decimal)) : null;
    return calcPrice;
  };

  const fromDollar = ({ token, amount, decimal = 6 }) => {
    if (isLoading || isError) return null;
    const price = tokenPrices?.[token];
    let calcPrice = 0;
    if (Number(amount) !== 0 && price != null && price > 0) {
      calcPrice = Number((amount / price).toFixed(decimal));
    }
    return calcPrice;
  };
  return { ...tokenPricesResult, toDollar, fromDollar };
};

export default useTokenPrices;
